import React from "react";
import {useContext, useEffect, useState} from "react";
import { FichaContext } from "../../context/FichaContext";
import { axiosPublic } from "../../helpers/axios";
import { block, unblock } from "../../helpers/loading";

export const SegundaPagina = () => {
  const [Razones, setRazones]=useState([]);
  const [Jornada, setJornada]=useState([]);
  const { data, setData } = useContext(FichaContext);
  const { segunda } = data;
  const { 
    razones,
    jornada,
    radiopc,
    radiointernet,
    radioestudio,
    radiotitulo,
    radiomatriculado} = segunda;
  
  const handleInputChange=({target})=>{
    setData({
        ...data,
        segunda: {
            ...segunda,
            [target.name]: target.value
        }
     });
  }

  useEffect(() => { 
      block();
      axiosPublic('razones')
      .then(response => setRazones(response.data.razon_ingreso))
      .catch(error => console.log(error));
      
      axiosPublic('jornadas')
      .then(response => setJornada(response.data.jornada))
      .catch(error => console.log(error));
      unblock();
    },[]);

return(
  <div className="container">
      <div className="cuerpo terc">
      <div className="titulo"><legend className="card-header">VIDA UNIVERSITARIA</legend></div>
          <div className="formu">
              <div className="form-floating">
                  <select className="txtfloat form-select" id="floatingSelect" name="razones" value={razones} onChange={handleInputChange}>
                      <option  disabled value={""}>Seleccionar...</option>
                      {Razones.map(razones => (  
                        <option className="opcion" key={razones.id} value={razones.id}>{razones.etiqueta}</option>
                      ))}
                  </select>
                  <label className="lb">Principal razón por la que elegió la UPNFM:</label>
              </div>

              <div className="form-floating">
                  <select className="txtfloat form-select" id="floatingSelect" name="jornada" value={jornada} onChange={handleInputChange}>
                      <option  disabled value={""}>Seleccionar...</option>
                      {Jornada.map(jornada => (  
                        <option className="opcion" key={jornada.id} value={jornada.id}>{jornada.etiqueta}</option>
                      ))}
                  </select>
                  <label className="lb">Jornada en que piensa matricular asignaturas:</label>
              </div>
          </div>
          <div className="formu">
              <div className="txtfloat2">
                  <label className="lb">Cuando estudie en la universidad ¿tendrá una computadora personal para apoyar sus estudios? :  &nbsp;&nbsp;</label>
                  <div>
                      <label className="form-check-label">Sí&nbsp;</label>
                      <input className="form-check-input" type="radio" name="radiopc" id="rdpc1" value={"S"} checked={radiopc==="S"} onChange={handleInputChange}/>
                          
                      <label className="form-check-label">&nbsp;&nbsp;No&nbsp;</label>
                      <input className="form-check-input" type="radio" name="radiopc" id="rdpc2" value={"N"} checked={radiopc==="N"} onChange={handleInputChange}/>
                 
                      <label className="form-check-label" >&nbsp;&nbsp;No Sé&nbsp;</label>
                      <input className="form-check-input" type="radio" name="radiopc" id="rdpc3" value={"NS"} checked={radiopc==="NS"} onChange={handleInputChange}/>
                  </div>
              </div>
              
              <div className="txtfloat2">
                  <label className="lb">Cuando estudie en la universidad ¿en su lugar de residencia tendrá acceso a internet para apoyar sus estudios?  :  &nbsp;&nbsp;</label>
                  <div>
                      <label className="form-check-label">Sí&nbsp;</label>
                      <input className="form-check-input" type="radio" name="radiointernet" id="rdinternet1" value={"S"} checked={radiointernet==="S"} onChange={handleInputChange}/>
                          
                      <label className="form-check-label">&nbsp;&nbsp;No&nbsp;</label>
                      <input className="form-check-input" type="radio" name="radiointernet" id="rdinternet2" value={"N"} checked={radiointernet==="N"} onChange={handleInputChange}/>
                  
                      <label className="form-check-label">&nbsp;&nbsp;No Sé&nbsp;</label>
                      <input className="form-check-input" type="radio" name="radiointernet" id="rdinternet3" value={"NS"} checked={radiointernet==="NS"} onChange={handleInputChange}/>
                  </div>
              </div>
          </div> 
          <div className="formu">
              <div className="txtfloat2">
                  <label className="lb">Tiempo para estudio  :  &nbsp;&nbsp;</label>
                      <div>
                          <label className="form-check-label">Completo&nbsp;</label>
                          <input className="form-check-input" type="radio" name="radioestudio" id="rdtestudio1" value={"C"} checked={radioestudio==="C"} onChange={handleInputChange}/>
                          
                          <label className="form-check-label">&nbsp;&nbsp;Parcial&nbsp;</label>
                          <input className="form-check-input" type="radio" name="radioestudio" id="rdtestudio2"  value={"P"} checked={radioestudio==="P"} onChange={handleInputChange}/>
                      </div>
              </div>
             
              <div className="txtfloat2">
                  <label className="lb">Actualmente ¿Se encuentra matriculado en alguna universidad?  :  &nbsp;&nbsp;</label>
                      <div>
                          <label className="form-check-label">Sí&nbsp;</label>
                          <input className="form-check-input" type="radio" name="radiomatriculado" id="rdmatriculado1" value={true} checked={radiomatriculado==="true"} onChange={handleInputChange}/>
                          
                          <label className="form-check-label">&nbsp;&nbsp;No&nbsp;</label>
                          <input className="form-check-input" type="radio" name="radiomatriculado" id="rdmatriculado2" value={false} checked={radiomatriculado==="false"} onChange={handleInputChange}/>
                      </div>
              </div>

               <div className="txtfloat2">
                  <label className="lb">¿Ha obtenido algún título universitario?  :  &nbsp;&nbsp;</label>
                      <div>
                          <label className="form-check-label">Sí&nbsp;</label>
                          <input className="form-check-input" type="radio" name="radiotitulo" id="rdtitulo1" value={true} checked={radiotitulo==="true"} onChange={handleInputChange}/>
                        
                          <label className="form-check-label">&nbsp;&nbsp;No&nbsp;</label>
                          <input className="form-check-input" type="radio" name="radiotitulo" id="rdtitulo2" value={false} checked={radiotitulo==="false"} onChange={handleInputChange}/>
                      </div>
              </div>
          </div>       
      </div>
  </div>   
);
}
